import { render, staticRenderFns } from "./I-0-3__IR-Corporate Management.vue?vue&type=template&id=20d08a6c&"
import script from "./I-0-3__IR-Corporate Management.vue?vue&type=script&lang=js&"
export * from "./I-0-3__IR-Corporate Management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports